export default __webpack_public_path__ + "static/media/property_1_7.554d05d6.webp";